/**
 * @generated SignedSource<<148e399b10ba798b0ef676af8e278862>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton$data = {
  readonly __id: string;
  readonly id: string;
  readonly project: {
    readonly id: string;
    readonly name: string;
  };
  readonly " $fragmentType": "projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton";
};
export type projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton$key = {
  readonly " $data"?: projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton",
  "selections": [
    {
      "kind": "RequiredField",
      "field": (v0/*: any*/),
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "project.id"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "project.name"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraNotificationProjectPreferences"
};
})();

(node as any).hash = "cb31c96fe2fdc342b82f1c11e02a88d6";

export default node;
